import React from 'react'
import Image from 'gatsby-image'
import styled from 'styled-components'
import Link from 'gatsby-link'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import Slide from 'react-reveal/Slide'

const TemplateWrapper = styled.div`
  .section {
    overflow: hidden;
    position: relative;
    > .gatsby-image-outer-wrapper {
      z-index: -1;
      position: absolute !important;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .gatsby-image-wrapper {
        height: 100%;
      }
    }
    .container {
      z-index: 4;
    }
  }

  .header-content {
    .container {
      padding: 3rem 0;
    }
  }
  .angleWrapper {
    height: 4rem;
    position: relative;
    box-shadow: 5px 5px 5px #000;
  }
  .angle-right {
    height: 100vh;
    background-color: white;
    transform: rotate(-4deg);
    width: 180vw;
    right: -20%;
    top: -50%;
    position: absolute;
  }
  .angle-left {
    height: 100vh;
    background-color: white;
    transform: rotate(4deg);
    width: 180vw;
    left: -25%;
    top: 20%;
    position: absolute;
  }
  .thumbnail-wrapper {
    border-radius: 15px;
    overflow: hidden;
    max-height: 600px;
    @media screen and (min-width: 768px) {
      margin-top: -100px;
      margin-bottom: -200px;
    }
    box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.2);
  }

  .content-title {
    padding: 0 2rem;
  }
  .content {
    padding: 3rem 2rem;
    margin-bottom: 3rem;
    line-height: 2rem;
  }
`

const Work = ({ data }) => (
  <TemplateWrapper>
    <HelmetDatoCms seo={data.datoCmsProject.seoMetaTags} />
    <section
      className="section is-medium "
      style={{
        background:
          'linear-gradient(360deg,' +
          data.datoCmsProject.accent.hex +
          ', ' +
          data.datoCmsProject.accent.hex +
          ' 15%, ' +
          'transparent)',
      }}
    >
      <Image sizes={data.datoCmsProject.headerImage.sizes} />
      <div className="header-content content">
        <div>
          <div className="container">
            <div className="columns">
              <div className="column is-7">
                <h1
                  className="title has-text-white is-size-1"
                  style={{ marginBottom: '3rem' }}
                >
                  Making Our Work Matter for{' '}
                  <a
                    href={data.datoCmsProject.websiteLink}
                    target="_blank"
                    style={{ color: '#fff' }}
                  >
                    <strong
                      style={{
                        textShadow: '2px 2px ' + data.datoCmsProject.accent.hex,
                        borderBottom:
                          'solid 3px' + data.datoCmsProject.accent.hex,
                      }}
                    >
                      {data.datoCmsProject.title}
                    </strong>
                  </a>
                </h1>
                <p className="subtitle has-text-white">
                  {data.datoCmsProject.projectDescription}
                </p>
                {/* <div className="tags"> */}
                {/*   {data.datoCmsProject.tags.map(tag => { */}
                {/*     return ( */}
                {/*       <span key={tag.id} className="has-text-dark is-medium"> */}
                {/*         <p>{tag.tag} </p> */}
                {/*       </span> */}
                {/*     ) */}
                {/*   })} */}
                {/* </div> */}
                <a
                  className="button is-medium"
                  style={{
                    backgroundColor: data.datoCmsProject.accent.hex,
                    borderColor: data.datoCmsProject.accent.hex,
                    color: '#ffffff',
                  }}
                  href={data.datoCmsProject.websiteLink}
                  target="_blank"
                >
                  Project Link
                </a>
              </div>
              <div className="webpage-thumbnail column is-4">
                <Slide bottom>
                  <div className="thumbnail-wrapper">
                    <a
                      href={data.datoCmsProject.websiteLink}
                      target="_blank"
                      className=""
                    >
                      <Image
                        sizes={data.datoCmsProject.webpageThumbnail.sizes}
                      />
                    </a>
                  </div>
                </Slide>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="angleWrapper">
        <div className="angle-left" />
        <div className="angle-right" />
      </div>
    </section>
    <div className="container">
      <div className="columns is-multiline">
        <div className="content-title column is-one-third">
          <h3 className="title">Background</h3>
          <hr style={{ backgroundColor: data.datoCmsProject.accent.hex }} />
        </div>
        <div
          className="content column is-two-thirds"
          dangerouslySetInnerHTML={{ __html: data.datoCmsProject.background }}
        />
        <div className="content-title column is-one-third">
          <h3 className="title">Challenge</h3>
          <hr style={{ backgroundColor: data.datoCmsProject.accent.hex }} />
        </div>
        <div
          className="content column is-two-thirds"
          dangerouslySetInnerHTML={{ __html: data.datoCmsProject.challenge }}
        />
        <div className="content-title column is-one-third">
          <h3 className="title">Solution</h3>
          <hr style={{ backgroundColor: data.datoCmsProject.accent.hex }} />
        </div>
        <div
          className="content column is-two-thirds"
          dangerouslySetInnerHTML={{ __html: data.datoCmsProject.solution }}
        />
        <div className="content-title column is-one-third">
          <h3 className="title">Benefits</h3>
          <hr style={{ backgroundColor: data.datoCmsProject.accent.hex }} />
        </div>
        <div
          className="content column is-two-thirds"
          dangerouslySetInnerHTML={{ __html: data.datoCmsProject.benefits }}
        />
      </div>
    </div>
    <section>
      <div className="container">
        <hr
          className="has-background-primary"
          style={{ marginBottom: '3rem' }}
        />
        <div className="buttons has-addons is-centered">
          <Link to="/work" className="button is-primary">
            ← Other Projects
          </Link>
          <Link to="/contact" className="button is-primary">
            Get Started →
          </Link>
        </div>
      </div>
    </section>
  </TemplateWrapper>
)

export default Work

export const WorkQuery = graphql`
  query WorkTemplateQuery($slug: String!) {
    datoCmsProject(slug: { eq: $slug }) {
      id
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      slug
      headerImage {
        sizes(maxWidth: 2600, imgixParams: { fm: "jpg", auto: "compress" }) {
          ...GatsbyDatoCmsSizes_noBase64
        }
      }
      thumbnail {
        sizes(maxWidth: 1600, imgixParams: { fm: "jpg", auto: "compress" }) {
          ...GatsbyDatoCmsSizes_noBase64
        }
      }
      webpageThumbnail {
        sizes(maxWidth: 1600, imgixParams: { fm: "jpg", auto: "compress" }) {
          ...GatsbyDatoCmsSizes_noBase64
        }
      }
      websiteLink
      title
      subtitle
      projectDescription
      tags {
        id
        tag
      }
      background
      challenge
      solution
      benefits
      accent {
        red
        green
        blue
        hex
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/work.js